export const iconFontAwesomeBuildingsMountainCity = (
	<i className="fa-solid fa-mountain-city"></i>
);
